import { Component, Input } from '@angular/core';
import { MessageDisplayModel } from './messageDisplay.model';

@Component({
  selector: 'message',
  templateUrl: './message.component.html'
})
export class MessageComponent {
  @Input() public messageDisplay: MessageDisplayModel;
  @Input() public isCentered?: boolean = false;
}
